import { type File as FileModel } from '@rentguru/commons-utils';

export const buildLiveFiles = (
  fileIdBatches: string[][],
  outcomes: PromiseSettledResult<FileModel[]>[]
): Map<string, FileModel | null> =>
  outcomes.reduce((acc: Map<string, FileModel | null>, outcome, index) => {
    if (outcome.status === 'rejected') {
      fileIdBatches[index].forEach((fileId) => acc.set(fileId, null));
      return acc;
    }
    outcome.value.forEach((file) => acc.set(file.id, file));
    return acc;
  }, new Map<string, FileModel | null>());
